import React from "react";

export const StepHeader = ({ step, title, kicker, testId }) => (
    <div data-testid={testId} className="mb-6 flex items-end justify-between gap-4 flex-wrap">
        <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                Step {step}
            </div>
            <h2 className="mt-2 font-heading text-2xl lg:text-3xl font-semibold tracking-tight text-slate-900">
                {title}
            </h2>
        </div>
        {kicker && (
            <div className="font-mono text-xs text-slate-500 max-w-md text-right">
                {kicker}
            </div>
        )}
    </div>
);

export default StepHeader;
